<template>
    <div class="card">
        <TabView @tab-change="handleTabChange">
            <TabPanel header="สรุปจำนวนอาคาร/สิ่งปลูกสร้าง">
                <report-building-amount></report-building-amount>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import reportBuildingAmount from './ReportBuildingAmount';

export default {
    components: {
        reportBuildingAmount
    },
    data() {
      return{
          
      }    
    },

    watch:{

    },

    mounted(){
    },

    methods: {
        handleTabChange(newTab){
            console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        }
    }
}
</script>